import React from 'react';

const ITEMS = [
  'Licensed & Insured',
  'White-Glove Service',
  'DC · MD · VA',
  'Satisfaction Guaranteed',
  'Discreet Teams',
  '100+ Spaces Cleaned',
  'Obsessive Detail',
  '48-Hr Re-Clean Guarantee',
];

const Row = () => (
  <>
    {ITEMS.map((item) => (
      <span key={item} className="inline-flex items-center text-[#07111c] text-[10px] uppercase font-semibold tracking-[0.32em] px-7">
        {item}
        <span className="ml-7 opacity-30">✦</span>
      </span>
    ))}
  </>
);

export const MarqueeTicker = () => {
  return (
    <div
      className="bg-[#C9A84C] py-3 overflow-hidden whitespace-nowrap"
      data-testid="marquee-ticker"
    >
      <div className="marquee-track inline-flex">
        {/* duplicate for seamless loop (translateX -50% at 100%) */}
        <div className="inline-flex">
          <Row />
          <Row />
          <Row />
          <Row />
        </div>
        <div className="inline-flex">
          <Row />
          <Row />
          <Row />
          <Row />
        </div>
      </div>
    </div>
  );
};
